/* eslint-disable no-unused-vars */
<template>
  <section class="main">
    <desktop-header active="upload-video" />

    <section class="upload-container">
      <h1 class="upload-title">导入作品</h1>
      <p class="upload-text">
        <!-- 请上传作品（格式: MP4）视频时长需要小于等于 10 分钟，视频文件大小控制在 300M 以内 -->
        请上传作品（格式：MP4、MP3）时长≤10分钟，视频文件大小控制在300M以内，音频文件大小控制在50M以内
      </p>
      <hr>
      <div class="upload-err-msg inline-block" style="display: none;"></div>
      <form @submit.prevent="submit">
        <div class="form-group">
          <label>作品中的歌曲<small>(选填，16个字以内)</small></label>
          <input type="text" class="form-control" placeholder="填写作品里提到的歌曲" maxlength="16" v-model.trim="song">
        </div>

        <div class="form-group">
          <label>作品描述<small>(选填，140个字以内)</small></label>
          <textarea class="form-control" rows="8" placeholder="填写作品描述" maxlength="140" v-model.trim="desc"></textarea>
        </div>

        <div class="form-group">
          <label>地区</label>
          <select class="form-control" v-model="area">
            <option value="">(无)</option>
            <option v-for="(item, index) in areaList" :key="index" :value="item">{{ item }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>上传作品<em>*</em><small>(必填，mp3、mp4格式)</small></label>
          <div class="form-control-group music-down">
            <input type="text" class="form-control" placeholder="未选择任何文件" readonly v-model="filename">
            <label class="custom-file-upload">
              <input type="file" class="form-control-file" @change="handleFileChange" ref="file" :disabled="disabled">
              选取文件
            </label>
          </div>

          <!-- <label>封面<em>*</em><small>(选填，格式jpeg、png，文件大小≤5MB，建议尺寸640*640)</small></label> -->
          <label>封面<em>*</em><small>(选填，格式jpeg、png，文件大小≤5MB。音频封面比例为1：1，建议尺寸640*640；<br>
            视频请上传与视频比例一致的封面。请按以上格式上传封面哦，否则可能出现封面不清晰的情<br>况，这样会让您的作品无法被推荐。)</small></label>
          <div class="img-container">
            <img class="cover-img" ref="previewImg1" :src="coverImg" alt="">
            <label class="check-img">
              <input type="file" ref="imgfile" class="form-control-file" @change="getCoverid($event)" accept="image/*">
              选择封面
            </label>
          </div>

          <div class="preview-container">
            <h1 class="p-intro">预览区</h1>
            <img class="cover-img p-img" ref="previewImg2" :src="coverImg" alt="">

            <div class="preview-intro">
              <div class="preview-info">
                <img class="preview-user-headphoto" src="~@cdn_img/head.png" alt="">
                <p class="preview-username">用户昵称</p>
                <p class="preview-btn"></p>
              </div>

              <p class="preview-title" v-show="isRecommend">
                <span class="title-icon">标题</span>
                <!-- <span v-show="isRecommend" class="p-title">{{ title }}</span> -->
                {{ title }}
              </p>

              <p class="preview-text">
                <span v-show="!desc">填写作品描述</span>
                {{ desc }}
              </p>

              <!-- <textarea class="preview-text" disabled type="text" placeholder="填写作品描述" maxlength="140" v-model.trim="desc"> </textarea> -->


              <div class="preview-footer">
                <img src="~@cdn_img/p-footer.jpg" alt="">
              </div>

            </div>
          </div>

          <div class="form-control-item">
            <label>
              <input type="checkbox" name="private" v-model="isPrivate">
              <span class="label-text">私密上传</span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <label>作品来源</label>
          <div>
            <label class="form-control-item radio-inline">
              <input type="radio" name="source" value="original" v-model="source">
              <span class="label-text">原创</span>
            </label>
            <label class="form-control-item radio-inline">
              <input type="radio" name="source" value="reprint" v-model="source">
              <span class="label-text">转载</span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="form-control-item">
            <label>
              <input type="checkbox" name="recommend" v-model="isRecommend">
              <span class="label-text">
                我要上推荐
                <small>作品通过审核后，将有机会推荐给其它用户</small>
                <button type="button" class="btn-link" @click="dialog = true">我要上推荐须知 &gt;</button>
              </span>
            </label>
          </div>
          <hr class="small">
        </div>

        <!-- <div class="form-group" v-show="false"> -->
        <div class="form-group" v-show="isRecommend">
          <label>作品标题<em>*</em><small>(必填，24个字以内)</small></label>
          <input type="text" class="form-control" placeholder="优质标题可吸引观看，小编可能会帮忙修改哦" maxlength="24" v-model.trim="title">
        </div>

        <div class="form-group" v-show="false">
          <!-- <div class="form-group" v-show="isRecommend"> -->
          <label>选择作品类型</label>
          <select class="form-control" v-model="category">
            <option value="">(请选择)</option>
            <option v-for="(item, index) in categoryList" :key="index" :value="item.id">{{ item.name }}</option>
          </select>
        </div>

        <div class="form-group" v-show="false">
          <!-- <div class="form-group" v-show="isRecommend"> -->
          <label>选择标签</label>
          <div>
            <template v-if="tagList.length">
              <label class="form-control-item checkbox-inline" v-for="(item, index) in tagList" :key="index">
                <input type="checkbox" name="tag" :value="item.id" v-model="tag">
                <span class="label-text">{{ item.name }}</span>
              </label>
            </template>
            <p class="empty" v-else>
              请先选择作品分类
            </p>
          </div>
        </div>

        <div class="form-group">
          <button type="submit" class="btn-primary" :disabled="disabled">确认上传</button>
        </div>
      </form>
    </section>

    <video class="hidden" controls ref="video"></video>
    <audio class="hidden" controls ref="audio"></audio>

    <div class="mask" v-show="loading">
      <div class="loader">
        <div class="loader-text" v-show="loaderText !== ''">{{ loaderText }}</div>
      </div>
    </div>

    <div class="toast-wrapper" v-show="toast">
      {{ toast }}
    </div>

    <div class="mask" v-show="dialog">
      <div class="dialog">
        <div class="title">
          我要上推荐须知
          <div class="close" @click="dialog = false"></div>
        </div>
        <div class="content">
          <pre>
是否注意到新版的推荐页上多了很多的视频内容呢？
如果你也喜欢用视频记录生活，就来唱吧发布自己的视频作品吧！满足以下要求的视频就有机会被小唱发现并展示在推荐页面哦！

1、作品的画质一定要清晰
2、画面比例恰当、拍摄角度佳、场景丰富、背景高级，总之是要给你的视频一个漂漂亮亮的环境
3、精心打扮过的你会很容易吸引小编的注意力，但可不要太夸张，不然会吓坏小编
4、内容一定要有创意、有看点，拒绝无聊、拒绝雷同
5、相信使用唱吧的你一定热爱音乐，所以视频中一定要出现音乐，背景音乐能符合视频的主题就最好不过了
6、如果你的视频以唱歌为主，那唱功能打动小编就非常重要了，一定要展现自己的演唱实力哦！
7、作品时长请尽量大于1分钟，时长低于30秒的视频不予通过
8、禁止假唱，体现在盗用其他人的声音来对口型；禁止盗用他人作品和恶意冒充他人
9、音频作品投稿要求：音频作品类型目前仅支持MP3格式；音频时长需要大于1分钟；请自觉上传合规内容，发现违规内容（黄色，暴力，恐怖，敏感等）将对账号严肃处理；投稿作品将由人工审核，小唱会加班加点为您审核，请不要一直催促噢
          </pre>
        </div>
      </div>
    </div>

    <desktop-footer />
  </section>
</template>

<script>
import fetch from '@module/helper/fetch';
import Cookies from 'js-cookie';
import DesktopHeader from '@module/component/desktop/Header';
import DesktopFooter from '@module/component/desktop/Footer';

export default {
  name: 'App',

  components: {
    DesktopHeader,
    DesktopFooter
  },

  data() {
    return {
      areaList: [],
      categoryList: {},
      tagList: [],
      memberId: '',

      song: '',
      title: '',
      desc: '',
      area: '',
      fileData: null,
      isPrivate: false,
      isRecommend: false,
      category: '',
      tag: [],
      source: 'original',

      disabled: false,
      filename: '',
      loading: false,
      loaderText: '',
      toast: '',
      dialog: false,

      imgData: '',
      coverImg: '//cbshowhot.cdn.changbaimg.com/-/97e7d3d209667f7f/cover-img.png',
      type: '',
      worktype: '',
      coverid: '',
      audioDuration: '',
      coverSize: '' //1 视频 2 音频

    }
  },

  watch: {
    category(value) {
      const found = this.categoryList[value];

      this.tag = [];
      this.tagList = found?.tag ?? [];
    },

    isRecommend() {
      this.tag = [];
      this.tagList = [];
      this.category = '';
    },

    coverSize(val) {
      console.log(val);
    }
  },

  created() {
    if (!this.isLogin()) {
      this.gotoLogin();
      return;
    }

    this.getInfo();
  },

  mounted() {
    const vEl = this.$refs.video;
    const aEl = this.$refs.audio;

    vEl.addEventListener('canplaythrough', (e) => {
      const width = e.target.videoWidth;
      const height = e.target.videoHeight;
      const duration = e.target.duration;

      if (duration > 10 * 60) {
        this.fileData = null;
        this.filename = '';

        alert(`视频时长需要小于 10 分钟，请重新选择`);

        return false;
      }

      if (duration < 15) {
        this.fileData = null;
        this.filename = '';

        alert(`视频时长不可少于 15 秒，请重新选择`);

        return false;
      }

      if ((height / width) < 0.25 || (height / width) > 4) {
        this.fileData = null;
        this.filename = '';

        alert(`你选择的视频尺寸不符合上传要求，请重新选择`);

        return false;
      }
    }, false);

    aEl.addEventListener('canplaythrough', (e) => {
      this.audioDuration = e.target.duration;

      // const duration = e.target.duration;

      // if (duration > 10 * 60) {
      //   this.fileData = null;
      //   this.filename = '';

      //   alert(`视频时长需要小于 10 分钟，请重新选择`);

      //   return;
      // }

      if (this.audioDuration < 1) {
        this.fileData = null;
        this.filename = '';

        alert(`音频时长为0，请重新选择`);

        return;
      }

    }, false);
  },

  methods: {

    async getCoverid(event) {
      const that = this;
      const file = event.target.files[0];
      console.log(file);

      if (file.size > 5 * 1024 * 1024) {
        alert(`封面大小超过限制，请重新选择`);

        return;
      } else {
        console.log(file.size);
      }

      const img1 = this.$refs.previewImg1;
      const img2 = this.$refs.previewImg2;

      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = function() {
        const base64 = this.result;
        const img = new Image();

        img.src = base64;
        img.onload = function() {
          that.imgInfo = {
            width: img.naturalWidth,
            height: img.naturalHeight
          };
          console.log("宽：" + img.naturalWidth + " 高：" + img.naturalHeight);

          const scale = img.naturalWidth / img.naturalHeight;

          // if (scale >= 0.5 && scale <= 0.625) {
          //   that.coverSize = 1;
          // }
          // else
          if (scale == 1) {
            that.coverSize = 2;
          }
          else {
            that.coverSize = 3;
          }

          img1.src = base64;
          img2.src = base64;

          that.uploadImg(file);
        }
      }

    },

    async uploadImg(file) {

      const { code, data } = await fetch('/api/uploadMV/web/uploadPoster', {
        method: 'post',
        upload: true,
        timeout: 1000 * 60 * 60,
        data: {
          imgdata: file
        }
      });

      if (code === 1) {
        this.coverid = data.coverid;
      }
      else if (code == -97) {
        this.gotoLogin();
      } else {
        alert('封面上传失败， 请重新上传');
      }
    },

    previewImage(target, file) {
      try {
        const src = window.URL.createObjectURL(file);
        target.onload = function() {
          window.URL.revokeObjectURL(this.src);
        };
        target.src = src;
      } catch (e) {
        throw new Error('browser doest not support URL')
      }
    },

    async getInfo() {
      const { code, data } = await fetch('/api/uploadMV/web/getSelectInfo');

      if (code === 1) {
        this.areaList = data.area;
        this.categoryList = data.list;
        this.memberId = data.memberid;
      }
      else if (code == -97) {
        this.gotoLogin();
      }
    },

    async submit() {
      // if (this.song == '') {
      //   alert(`歌曲名称未填写，不可上传`);
      //   return;
      // }

      // if (this.desc == '') {
      //   alert(`视频描述未填写，不可上传`);
      //   return;
      // }

      // if (this.worktype == 1 && (this.coverSize != 1 && this.coverSize != '')) {
      //   alert('视频封面比例为9：16，其他比例不支持上传');
      //   return;
      // }

      if (this.worktype == 2 && (this.coverSize != 2 && this.coverSize != '')) {
        alert('音频封面比例为1：1，建议尺寸640*640，其他比例不支持上传');
        return;
      }

      if (this.worktype == 2 && this.isRecommend) {

        if (this.audioDuration < 60) {
          alert(`投稿音频时长不可少于 60 秒，请重新选择`);
          return;
        }
      }

      if (this.fileData == null) {
        alert(`作品文件未选择，不可上传`);
        return;
      }

      if (this.isRecommend && this.isPrivate) {
        alert(`私密上传的作品，不可勾选我要上推荐`);
        return;
      }

      if (this.isRecommend) {
        if (this.title == '') {
          alert(`作品推荐语未填写，不可上传`);
          return;
        }
      }

      if (!this.isRecommend) {
        this.title = '';
      }

      this.loading = true;
      this.disabled = true;

      console.log(this.fileData);
      console.log(this.coverid);

      const upData = {
        worktype: this.worktype, //  1是视频 2 是音频

        mvname: this.song,
        headcontent: this.title,
        worktitle: this.desc,
        area: this.area,
        mvSecrect: this.isPrivate ? 'yes' : 'no',
        needrecommend: this.isRecommend ? 'yes' : 'no',
        workcategory: this.category,
        worktag: this.tag,
        source: this.source,
        // file_mv: this.fileData,
        // file_audio: this.fileData,
        // audioDuration: this.audioDuration,
        coverid: this.coverid
      }

      if (this.worktype == 1) {
        const key = 'file_mv';
        upData[key] = this.fileData;

      } else {
        const key = 'file_audio', duration = 'audioDuration';
        upData[key] = this.fileData;
        upData[duration] = this.audioDuration;
      }

      console.log(upData);

      const { code, msg } = await fetch('/api/uploadMV/web/uploadMV', {
        method: 'post',
        upload: true,
        timeout: 1000 * 60 * 60,
        data: Object.assign({}, upData),

        // {
        //   upData
        //   // worktype: this.worktype, //  1是视频 2 是音频

        //   // mvname: this.song,
        //   // headcontent: this.title,
        //   // worktitle: this.desc,
        //   // area: this.area,
        //   // mvSecrect: this.isPrivate ? 'yes' : 'no',
        //   // needrecommend: this.isRecommend ? 'yes' : 'no',
        //   // workcategory: this.category,
        //   // worktag: this.tag,
        //   // source: this.source,
        //   // // file_mv: this.fileData,

        //   // file_audio: this.fileData,
        //   // coverid: this.coverid
        // },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            this.loaderText = `上传中(${Math.floor((progressEvent.loaded / progressEvent.total) * 100)}%)`;
          }
        }
      });

      this.loading = false;
      this.disabled = false;

      if (code == 1) {
        this.disabled = true;
        this.toast = '上传成功';

        setTimeout(() => {
          window.location = `/u/${this.memberId}`;
        }, 1500);
      }
      else if (code == -97) {
        this.gotoLogin();
      }
      else {
        alert(msg);
      }
    },

    handleFileChange() {
      const el = this.$refs.file;
      const file = el.files[0];

      el.value = null;

      const filename = file.name;

      this.fileData = null;
      this.filename = '';


      if (filename.substring(filename.lastIndexOf('.')).toLowerCase() === '.mp4' || filename.substring(filename.lastIndexOf('.')).toLowerCase() === '.mp3') {
        console.log(filename.substring(filename.lastIndexOf('.')).toLowerCase())
        this.type = filename.substring(filename.lastIndexOf('.')).toLowerCase();
      }
      else {
        alert(`视频格式不符合要求，请重新选择`);

        return;
      }

      if (this.type == '.mp4') {
        this.worktype = 1;

        if (file.size > 300 * 1024 * 1024) {
          alert(`视频大小超过限制，请重新选择`);

          return;
        }
      } else {
        this.worktype = 2;

        if (file.size > 50 * 1024 * 1024) {
          alert(`音频大小超过限制，请重新选择`);

          return;
        }
      }

      this.fileData = file;
      this.filename = filename;

      if (window.URL) {
        this.type == '.mp4' ? this.$refs.video.src = URL.createObjectURL(file) : this.$refs.audio.src = URL.createObjectURL(file);
      }
    },

    isLogin() {
      return Cookies.get('PHPSESSID');
    },

    async logout() {
      await fetch('/api/musicService/site/logout');

      Cookies.remove('PHPSESSID', { path: '/', domain: '.changba.com' });
      Cookies.remove('PHPSESSID', { path: '/', domain: 'changba.com' });
    },

    gotoLogin() {
      if (process.env.NODE_ENV === 'development') {
        Cookies.set('PHPSESSID', 'test');
        // window.location.reload();
      }
      else {
        window.location = '/official_login.php?redirect=' + window.btoa(encodeURIComponent(window.location.href));
      }
    }
  }
};
</script>

<style lang="scss">
html,
body {
  background-color: #f0f0f0;
}

.hidden {
  display: none;
}

.main {
  .upload-container {
    position: relative;
    width: 980px;
    margin: 30px auto;
    padding: 20px;
    color: #333;
    font-size: 14px;
    background-color: #fff;
    border: 1px solid #dadada;

    .upload-title {
      margin: 0;
      font-size: 24px;
    }

    .upload-text {
      margin-top: 10px;
      margin-bottom: 0;
      color: #867e77;
    }

    hr {
      margin-top: 16px;
      margin-bottom: 16px;
      border-color: #dadada;
      border-style: solid;
      border-top: 0;

      &.small {
        margin-top: 0;
      }
    }


    .form-group {
      margin-bottom: 15px;

      label {
        display: inline-block;
        max-width: 100%;
        margin-bottom: 5px;
        color: #333;
        font-size: 16px;

        em {
          margin-right: 5px;
          margin-left: 5px;
          color: #ff2f00;
          font-style: normal;
          line-height: 1;
          vertical-align: middle;
        }

        small {
          color: #999;
          font-size: 14px;
        }
      }

      .form-control {
        display: block;
        width: 100%;
        height: 36px;
        padding: 6px 12px;
        font-size: 16px;
        background-color: #fff;
        background-image: none;
        border: 1px solid #d8d8d8;

        &:focus {
          border-color: #f37c5c;
          outline: 0;
        }

        &::placeholder {
          color: #ccc;
          font-size: 14px;
        }
      }

      .form-control-file {
        position: absolute;
        z-index: -1;
        width: 0.1px;
        height: 0.1px;
        overflow: hidden;
        opacity: 0;
      }

      .custom-file-upload {
        display: inline-block;
        height: 36px;
        margin-bottom: 0;
        margin-left: 20px;
        padding-right: 18px;
        padding-left: 18px;
        color: #666;
        font-size: 16px;
        line-height: 36px;
        white-space: nowrap;
        text-align: center;
        vertical-align: middle;
        background-color: #eee;
        background-image: none;
        border: 0;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;
      }

      .form-control-group {
        display: flex;
      }

      .btn-link {
        color: #ff734e;
        font-size: 14px;
        border: 0;
        cursor: pointer;

        &:focus {
          outline: 0;
        }
      }

      .btn-primary {
        width: 226px;
        height: 40px;
        color: #fff;
        font-size: 16px;
        background-color: #ff734e;
        border: 0;
        border-radius: 6px;
        cursor: pointer;
      }

      .empty {
        margin-top: 5px;
        color: #999;
        font-size: 14px;
      }

      textarea.form-control {
        width: 366px;
        height: auto;
        min-height: 34px;
        resize: vertical;
      }

      input[type=text].form-control,
      select.form-control {
        width: 366px;
      }

      input[type=file] {
        display: block;
      }
    }
  }
}

$color: #ff734e;

.form-control-item {
  margin-top: 5px;

  &.checkbox-inline,
  &.radio-inline {
    margin-top: 4px;
    margin-right: 15px;
    padding-top: 0;
    padding-left: 0;
  }

  /**remove default style**/
  [type="radio"] {
    position: absolute;
    left: -9999px;
    visibility: hidden;
  }

  [type="radio"] + .label-text {
    position: relative;
    display: inline-block;
    height: 25px;
    padding-left: 22px;
    color: #878787;
    font-size: 16px;
    line-height: 25px;
    transition: .28s ease;
    user-select: none;
  }

  [type="radio"] + .label-text:before,
  [type="radio"] + .label-text:after {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 16px;
    height: 16px;
    margin: 4px;
    margin-left: 0;
    border-radius: 50%;
    transition: .28s ease;
    content: '';
  }

  [type="radio"] + .label-text:after {
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
  }

  /* Unchecked styles */
  [type="radio"]:not(:checked) + .label-text:before {
    background-color: #fff;
    border: 1px solid #dadada;
    border-radius: 50%;
  }

  [type="radio"]:not(:checked) + .label-text:after {
    z-index: -1;
    border: 3px solid #dadada;
    border-radius: 50%;
  }

  [type="radio"]:not(:checked) + .label-text:hover:before {
    border-color: $color;
  }

  /* Checked styles */
  [type="radio"]:checked + .label-text:before {
    border: 1px solid $color;
  }

  [type="radio"]:checked + .label-text:after {
    z-index: 0;
    background-color: $color;
    border: 3px solid #fff;
  }

  /* Disabled style */
  [type="radio"]:disabled:not(:checked) + .label-text:before,
  [type="radio"]:disabled:checked + .label-text:before {
    background-color: transparent;
    border-color: #eee;
  }

  [type="radio"]:disabled + .label-text {
    color: #d2d6de;
    cursor: not-allowed;
  }

  [type="radio"]:disabled:not(:checked) + .label-text:hover:before {
    border-color: #eee;
  }

  [type="radio"]:disabled:checked + .label-text:after {
    background-color: #eee;
  }

  /* Remove default checkbox */
  [type="checkbox"] {
    position: absolute;
    left: -9999px;
  }

  [type="checkbox"] + .label-text {
    position: relative;
    display: inline-block;
    height: 25px;
    padding-left: 22px;
    color: #878787;
    font-size: 16px;
    line-height: 25px;
    user-select: none;
  }

  [type="checkbox"] + .label-text:before {
    position: absolute;
    top: 5px;
    left: 0;
    z-index: 0;
    width: 16px;
    height: 16px;
    border: 1px solid #dadada;
    border-radius: 1px;
    transition: 0.2s;
    content: '';
  }

  [type="checkbox"] + .label-text:after {
    position: absolute;
    top: 6px;
    left: 0;
    z-index: 0;
    width: 6px;
    height: 12px;
    border: 2px solid #fff;
    border-top: 2px solid transparent;
    border-left: 2px solid transparent;
    border-radius: 1px;
    transform: rotate(40deg);
    transform-origin: 100% 100%;
    -webkit-backface-visibility: hidden;
    transition: 0.2s;
    content: '';
  }

  [type="checkbox"]:not(:checked):disabled + .label-text:before {
    border-color: #eee;
  }

  [type="checkbox"]:not(:checked) + .label-text:hover:before {
    border-color: $color;
  }

  [type="checkbox"]:checked + .label-text:after {
    border-right-color: #fff;
    border-bottom-color: #fff;
  }

  [type="checkbox"]:checked + .label-text:before {
    background-color: $color;
    border-color: $color;
  }

  [type="checkbox"]:checked:disabled + .label-text:before {
    border-color: #eee;
  }

  [type="checkbox"]:checked:disabled + .label-text:after {
    border-right-color: #eee;
    border-bottom-color: #eee;
  }

  [type="checkbox"]:not(:checked):disabled + .label-text:hover:before {
    border-color: #eee;
  }

  [type="checkbox"]:disabled + .label-text {
    color: #d2d6de;
    cursor: not-allowed;
  }
}

.toast-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 92;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 260px;
  height: 50px;
  margin-top: -25px;
  margin-left: -130px;
  color: #fff;
  font-size: 20px;
  background: rgba(0, 0, 0, .5);
  border-radius: 5px;
}

.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);

  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 100;
    width: 1em;
    height: 1em;
    font-size: 10px;
    border-radius: 50%;
    transform: translateZ(0) translate(-50%, -50%);
    animation: load5 1.1s infinite ease;

    .loader-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 4em;
      margin-top: 2em;
      margin-left: -1.6em;
      color: #fff;
      font-size: 24px;
      text-align: center;
    }
  }

  .dialog {
    position: absolute;
    top: 111px;
    left: 50%;
    z-index: 50;
    width: 650px;
    background-color: #fff;
    transform: translateX(-50%);

    .title {
      position: relative;
      height: 50px;
      padding-left: 20px;
      color: #615d5d;
      font-size: 18px;
      line-height: 50px;
      background-color: #f8f8f8;
      border-bottom: 1px solid #d8d8d8;

      .close {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 56px;
        border-left: 1px solid #d8d8d8;
        cursor: pointer;

        &::after {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 18px;
          height: 17px;
          background-image: url('~@cdn_img/close.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          transform: translate(-50%, -50%);
          content: '';

        }
      }
    }

    .content {
      color: #333;
      font-size: 14px;
      line-height: 1.45;

      pre {
        margin: 1em;
        white-space: pre-wrap;
      }
    }
  }

}

@keyframes load5 {
  0%,
  100% {
    box-shadow: 0 -2.6em 0 0 #fff, 1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2), 2.5em 0 0 0 rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0 rgba(255, 255, 255, 0.2), 0 2.5em 0 0 rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0 rgba(255, 255, 255, 0.2), -2.6em 0 0 0 rgba(255, 255, 255, 0.5), -1.8em -1.8em 0 0 rgba(255, 255, 255, 0.7);
  }

  12.5% {
    box-shadow: 0 -2.6em 0 0 rgba(255, 255, 255, 0.7), 1.8em -1.8em 0 0 #fff, 2.5em 0 0 0 rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0 rgba(255, 255, 255, 0.2), 0 2.5em 0 0 rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0 rgba(255, 255, 255, 0.2), -2.6em 0 0 0 rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0 rgba(255, 255, 255, 0.5);
  }

  25% {
    box-shadow: 0 -2.6em 0 0 rgba(255, 255, 255, 0.5), 1.8em -1.8em 0 0 rgba(255, 255, 255, 0.7), 2.5em 0 0 0 #fff, 1.75em 1.75em 0 0 rgba(255, 255, 255, 0.2), 0 2.5em 0 0 rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0 rgba(255, 255, 255, 0.2), -2.6em 0 0 0 rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2);
  }

  37.5% {
    box-shadow: 0 -2.6em 0 0 rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0 rgba(255, 255, 255, 0.5), 2.5em 0 0 0 rgba(255, 255, 255, 0.7), 1.75em 1.75em 0 0 #fff, 0 2.5em 0 0 rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0 rgba(255, 255, 255, 0.2), -2.6em 0 0 0 rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2);
  }

  50% {
    box-shadow: 0 -2.6em 0 0 rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2), 2.5em 0 0 0 rgba(255, 255, 255, 0.5), 1.75em 1.75em 0 0 rgba(255, 255, 255, 0.7), 0 2.5em 0 0 #fff, -1.8em 1.8em 0 0 rgba(255, 255, 255, 0.2), -2.6em 0 0 0 rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2);
  }

  62.5% {
    box-shadow: 0 -2.6em 0 0 rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2), 2.5em 0 0 0 rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0 rgba(255, 255, 255, 0.5), 0 2.5em 0 0 rgba(255, 255, 255, 0.7), -1.8em 1.8em 0 0 #fff, -2.6em 0 0 0 rgba(255, 255, 255, 0.2), -1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2);
  }

  75% {
    box-shadow: 0 -2.6em 0 0 rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2), 2.5em 0 0 0 rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0 rgba(255, 255, 255, 0.2), 0 2.5em 0 0 rgba(255, 255, 255, 0.5), -1.8em 1.8em 0 0 rgba(255, 255, 255, 0.7), -2.6em 0 0 0 #fff, -1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2);
  }

  87.5% {
    box-shadow: 0 -2.6em 0 0 rgba(255, 255, 255, 0.2), 1.8em -1.8em 0 0 rgba(255, 255, 255, 0.2), 2.5em 0 0 0 rgba(255, 255, 255, 0.2), 1.75em 1.75em 0 0 rgba(255, 255, 255, 0.2), 0 2.5em 0 0 rgba(255, 255, 255, 0.2), -1.8em 1.8em 0 0 rgba(255, 255, 255, 0.5), -2.6em 0 0 0 rgba(255, 255, 255, 0.7), -1.8em -1.8em 0 0 #fff;
  }
}


.img-container {
  position: relative;
  width: 200px;
  /* height: 200px; */
}

.cover-img {
  display: block;
  width: 200px;
  /* height: 200px; */
}

.music-down {
  margin-bottom: 14px;
}

.check-img {
  position: absolute;
  bottom: 0;
  left: 0;
  display: inline-block;
  width: 200px;
  height: 40px;
  margin-bottom: 0 !important;
  padding-right: 18px;
  padding-left: 18px;
  color: #fff !important;
  font-size: 16px;
  line-height: 36px;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, .5);
  background-image: none;
  border: 0;
  cursor: pointer;
  user-select: none;
}

/* 预览 */
.p-intro {
  position: absolute;
  top: -60px;
  right: 0;
  font-size: 24px;
  /* background-color: pink; */
  color: #121212;
  width: 277px;
  text-align: center;
}

.preview-container {
  position: absolute;
  top: 400px;
  right: 68px;
  width: 277px;
  background-color: #161622;
  color: #fff;
  font-size: 12px;

  .p-img {
    width: 277px;
  }
}

.preview-info {
  display: flex;
  align-items: center;
  font-size: 16px;

  .preview-user-headphoto {
    margin: 0 9px;
    width: 44px;
    height: 44px;
  }

  .preview-btn {
    margin-left: 90px;
    width: 46px;
    height: 22px;
    background: url(~@cdn_img/care.png) no-repeat;
    background-size: 100% 100%;
  }
}

.preview-footer {
  img {
    width: 277px;
    height: 37px;
  }
}

.preview-title {
  position: relative;
  padding-left: 53px;
  width: 250px;
  min-height: 18px;
  font-size: 12px;
  color: #ffffff;
  opacity: 0.8;
  line-height: 18px;

  .title-icon {
    position: absolute;
    top: 2px;
    left: 10px;
    width: 29px;
    height: 17px;
    font-size: 12px;
    text-align: center;
    line-height: 17px;
    color: #161622;
    border-radius: 2px;
    background-color: #74747b;
  }
}

.preview-text {
  margin-left: 11px;
  width: 240px;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.5;
}


</style>
